/* Brainy Bounce interactions. All motion respects the Motion toggle and reduced-motion settings. */
(function () {
  var doc = document.documentElement;
  var COLORS = ['#ff2e93', '#b6f23a', '#b9a4ff', '#2fe0d6', '#ffd23f'];
  function still() { return doc.classList.contains('bb-still'); }
  if ('IntersectionObserver' in window) doc.classList.add('bb-js');

  /* ---------- Motion toggle (state set early in theme.liquid) ---------- */
  function syncToggles() {
    var on = !still();
    document.querySelectorAll('[data-bb-motion-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = b.querySelector('.bb-motion__label'); if (l) l.textContent = on ? 'Motion on' : 'Motion off';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bb-motion-toggle]'); if (!b) return;
    var on = still();               // currently still -> turn on
    doc.classList.toggle('bb-still', !on);
    try { localStorage.setItem('bb-motion', on ? 'on' : 'off'); } catch (err) {}
    syncToggles();
    document.dispatchEvent(new CustomEvent('bb:motion', { detail: { on: on } }));
  });

  /* ---------- Bounce-in on scroll ---------- */
  var popIO = null;
  function watchPops(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (!popIO) popIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); popIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    (scope || document).querySelectorAll('.bb-pop-in:not(.is-in)').forEach(function (el) { popIO.observe(el); });
  }

  /* ---------- Hero background depth follows the pointer ---------- */
  function heroDepth(hero) {
    if (hero.__bbd) return; hero.__bbd = true;
    var raf = 0;
    hero.addEventListener('pointermove', function (e) {
      if (still() || raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--px', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
        hero.style.setProperty('--py', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
      });
    });
  }

  /* ---------- Illustrated Bo: eyes follow, tap to squish ---------- */
  function mascots(scope) {
    (scope || document).querySelectorAll('[data-bb-mascot]').forEach(function (m) {
      if (m.__bb) return; m.__bb = true;
      m.addEventListener('click', function () { m.classList.remove('is-squished'); void m.offsetWidth; m.classList.add('is-squished'); });
    });
  }
  var lookRaf = 0;
  document.addEventListener('pointermove', function (e) {
    if (lookRaf || still()) return;
    lookRaf = requestAnimationFrame(function () {
      lookRaf = 0;
      document.querySelectorAll('[data-bb-mascot] .bb-mascot__look').forEach(function (g) {
        var svg = g.ownerSVGElement; if (!svg || !svg.getClientRects().length) return;
        var r = svg.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
        var d = Math.hypot(dx, dy) || 1, k = Math.min(1, d / 400);
        g.style.transform = 'translate(' + ((dx / d) * 9 * k).toFixed(1) + 'px,' + ((dy / d) * 7 * k).toFixed(1) + 'px)';
      });
    });
  }, { passive: true });

  /* ---------- Image gallery: thumbnails, swipe, arrow keys ---------- */
  function galleries(scope) {
    (scope || document).querySelectorAll('[data-bb-gallery]').forEach(function (g) {
      if (g.__bb) return; g.__bb = true;
      var track = g.querySelector('.bb-gallery__track');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.bb-gallery__thumb'));
      function go(i) {
        i = Math.max(0, Math.min(thumbs.length - 1, i));
        track.scrollTo({ left: track.clientWidth * i, behavior: still() ? 'auto' : 'smooth' });
        mark(i);
      }
      function mark(i) { thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); }); }
      function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      });
      var t0 = 0;
      track.addEventListener('scroll', function () { clearTimeout(t0); t0 = setTimeout(function () { mark(current()); }, 80); }, { passive: true });
    });
  }

  /* ---------- Advent doors (decorative placeholder) ---------- */
  document.addEventListener('click', function (e) {
    var d = e.target.closest('.bb-door'); if (!d) return;
    var open = d.getAttribute('aria-pressed') === 'true';
    d.setAttribute('aria-pressed', open ? 'false' : 'true');
    d.setAttribute('aria-label', (open ? 'Open door ' : 'Close door ') + d.querySelector('.bb-door__num').textContent.trim());
  });

  /* ---------- Add to cart (real Shopify cart; shows the real result) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-bb-add]'); if (!f || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]'), msg = f.querySelector('.bb-card__msg');
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); msg.textContent = ''; msg.classList.remove('is-error');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (r) {
        if (!r.ok || r.j.status) throw new Error(r.j.description || r.j.message || 'Could not add this toy.');
        msg.innerHTML = 'Added! <a href="' + ((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart') + '">View cart</a>';
        var b = btn.getBoundingClientRect(); confetti(b.left + b.width / 2, b.top, 30);
        updateCount();
      })
      .catch(function (err) { msg.textContent = err.message; msg.classList.add('is-error'); })
      .finally(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  });
  function updateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('cart-count, .cart-bubble__text-count, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }

  /* ---------- Confetti ---------- */
  function confetti(x, y, n) {
    if (still() || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    for (var i = 0; i < (n || 30); i++) {
      var p = document.createElement('span');
      p.className = 'bb-confetti';
      p.style.left = x + 'px'; p.style.top = y + 'px';
      p.style.background = COLORS[i % COLORS.length];
      p.style.setProperty('--x', (Math.random() - 0.5) * 340 + 'px');
      p.style.setProperty('--y', (Math.random() * -240 + 110) + 'px');
      p.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
      document.body.appendChild(p);
      setTimeout(function (node) { return function () { node.remove(); }; }(p), 1200);
    }
  }
  // Horizon's own add-to-cart buttons get confetti too (decoration only)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('add-to-cart-component button, button[name="add"]'); if (!b || b.disabled) return;
    var r = b.getBoundingClientRect(); confetti(r.left + r.width / 2, r.top, 24);
  });

  /* ---------- Press feedback for touch ---------- */
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest('.bb-btn'); if (!b) return;
    b.classList.add('is-pressed'); setTimeout(function () { b.classList.remove('is-pressed'); }, 160);
  });

  function init(scope) {
    syncToggles(); watchPops(scope); mascots(scope); galleries(scope);
    (scope || document).querySelectorAll('[data-bb-hero]').forEach(heroDepth);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
